// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 5C7.34315 5 6 6.34315 6 8C6 9.65685 7.34315 11 9 11V13C6.23858 13 4 15.2386 4 18V22H2V18C2 15.3075 3.52021 12.97 5.74913 11.7991C4.67847 10.882 4 9.52024 4 8C4 5.23858 6.23858 3 9 3H10V5H9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 8C10 5.23858 12.2386 3 15 3C17.7614 3 20 5.23858 20 8C20 10.7614 17.7614 13 15 13C12.2386 13 10 10.7614 10 8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.2251 14C15.1629 15.0028 14.5 16.424 14.5 18C14.5 19.576 15.1629 20.9972 16.2251 22H7V19C7 16.2386 9.23858 14 12 14H16.2251Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24.0004 18.9999V16.9999H21.0004V13.9999H19.0004V16.9999L16.0004 16.9999V18.9999L19.0004 18.9999L19.0004 21.9999H21.0004L21.0004 18.9999H24.0004Z"}}]};

const UsergroupAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'usergroup-add-filled',
    ref,
    icon: element,
  },
));

UsergroupAddFilledIcon.displayName = 'UsergroupAddFilledIcon';

export default UsergroupAddFilledIcon;
